import { Pipe, PipeTransform } from '@angular/core';
import { DateUtil } from '../util/date.util';

@Pipe({
  name: 'fancyDateOnly'
})
export class FancyDateOnlyPipe implements PipeTransform {

  transform(value: any) {
    if (value != null && value != 0) {
      if (value.seconds) {
        let newDate = new Date(value.seconds * 1000);
        // return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getHours() + ":" + newDate.getMinutes();    
        return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getFullYear();
      } if (value._seconds) {
        let newDate = new Date(value._seconds * 1000);
        // return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getHours() + ":" + newDate.getMinutes();    
        return newDate.getDate() + "" + DateUtil.getMonthString("" + (newDate.getMonth() + 1)) + " " + newDate.getFullYear();
      } else {
        if (typeof value === 'string' || value instanceof String) {
          value = new Date(value + "");
        } else {
          if (Number.isInteger(value)) {
            value = new Date(value);
          }


        }
        return value.getDate() + "" + DateUtil.getMonthString("" + (value.getMonth() + 1)) + " " + value.getFullYear();
      }
    } else {
      return "-";
    }
  }
}
